import axios from 'axios';
import store from '@/store';

export default ({ endpoint = '/metrics/get_table_metrics', table = '', locale = 'pt-BR' } = {}) => {
  const { user } = store.getters;

  return axios.get(endpoint, {
    params: {
      locale: user.language || locale,
      tbl: table,
    },
  });
};
